import { createContext, useContext } from "react";

export interface HireModalApi {
  /** Abre el modal rapido de contratacion para un empleado (id de t.virtualTeam.members).
   *  `source` dice desde donde se pidio (el titulo de la nota, por ejemplo) y
   *  viaja en el aviso: sin el, todo pedido figura como "desde la home". */
  open: (employeeId: string, source?: string) => void;
}

export const HireModalContext = createContext<HireModalApi | null>(null);

export function useHireModal(): HireModalApi {
  const api = useContext(HireModalContext);

  if (!api) {
    throw new Error("useHireModal necesita estar dentro de <HireModalProvider>.");
  }

  return api;
}
